import React from 'react';
import classes from './index.module.css'
import { TableCell, TableHead, TableRow, TableSortLabel, Theme, createStyles, withStyles } from '@material-ui/core';
import RonadIcons from '../../iconComponent';

type Props = {
  order: 'asc' | 'desc'
  orderBy: string
  onSort: (e:React.MouseEvent<unknown, MouseEvent>,p:string | number | symbol) => void
  headCells: any[]
  action?: (row: any) => JSX.Element
}
type Ord = 'asc' | 'desc';

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      padding: '10px 0',
      backgroundColor: '#d3d6e8 !important',
      color: '#212121',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  })
)(TableCell);

const IconSort = (order: Ord) => {
  return (
    <RonadIcons name={order === 'asc' ? 'chevron-down' : 'chevron-up'} size="20px" />
  );
};

function SimpleTableHead(props: Props) {
  const { order, orderBy, onSort, headCells, action } = props;
  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      onSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => {
          let orderStatus = orderBy === headCell.id ? order : 'asc';
          return (
            <StyledTableCell
              key={headCell.id}
              align={headCell.align ? headCell.align :"left"}
              sortDirection={orderBy === headCell.id ? order : false}
              data-cy={headCell.id}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                IconComponent={() => IconSort(orderStatus)}
              >
                <span className={classes.columnText}>{headCell.label}</span>
              </TableSortLabel>
            </StyledTableCell>
          );
        })}
        {action && <StyledTableCell align="right"/>}
      </TableRow>
    </TableHead>
  );
}

export default SimpleTableHead